import { AuditReportsGipReportScheduleDto } from '@mi-front/api-v2';
import { MrtTable } from '@mi-front/ui';
import { MRT_ColumnDef } from 'material-react-table';
import { useGipResultColumnsFactory } from './useGipResultColumnsFactory';

interface Props {
  schedules: AuditReportsGipReportScheduleDto[];
}

export const GipReportFutureSchedulesView = ({ schedules }: Props) => {
  const columns = useGipResultColumnsFactory();

  const tableColumns = [
    columns.station,
    columns.dateTime,
    columns.materialStatus,
    columns.advertiser,
    columns.campaign,
    columns.version,
    columns.contract,
    columns.order,
  ] as unknown as MRT_ColumnDef<AuditReportsGipReportScheduleDto>[];

  return <MrtTable<AuditReportsGipReportScheduleDto> data={schedules} columns={tableColumns} />;
};
